import React from "react";
import "./styles.css";
import "../CETDashBoard/CETDashBoard.css";
import { Col, Row } from "react-bootstrap";
import { Routes, Route, Navigate } from "react-router-dom";
import LeadManagementDashboardList from "./LeadManagementDashboardList";
import useWindowSize from "../../utils/useWindowSize";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import LeadManagement from "../leadMangement/LeadManagement";
import EditPartner from "../PartnerManagement/EditPartner/EditPartner";
import ViewLeadDetails from "../leadMangement/ViewLeadDetails";
import LeadMobileHeader from "./LeadMobileHeader";
import { getLeadDetails } from "../../redux/viewlead/action";
import AddLeadDocument from "../leadMangement/AddLeadDocument/AddLeadDocument";
import DashBoard from '../DashBoard/DashBoard'
// import PartnerDashBoardList from "../PartnerPayoutDashboard/PartnerDashboardList";
import PartnerPayoutDashboard from "../PartnerPayoutDashboard/PartnerPayoutDashboard";

import AddLead from "../leadMangement/AddLead/AddLead";
import EditLead from "../leadMangement/EditLead/EditLead";
import LanPayoutDashboard from "../PartnerPayoutDashboard/LanPayoutDashboard";
import AdvanceDashboard from "../DashBoard/AdvanceDashboard";
import UserManagement from "../UserManagement/UserManagement";

const routes = [
  {
    path: "/dashBoard",
    element: <DashBoard />,
  },
  {
    path: "/AdvancedDashBoard",
    element: <AdvanceDashboard />,
  },
  {
    path: "/leadManagement",
    element: <LeadManagement />,
  },
  {
    path: "/viewPartner",
    element: <EditPartner />,
  },
  {
    path: "/view-lead",
    element: <ViewLeadDetails />,
  },
  {
    path: "/view-leadDoc",
    element: <AddLeadDocument />,
  },
  {
    path: "/payoutDashboard",
    element: <PartnerPayoutDashboard />,
  },
  {
    path:"/payoutDashboard/Details/:monthlyReportId",
    element: <LanPayoutDashboard />
  },
  {
    path: "/addLeadDoc",
    element: <AddLeadDocument />,
  },
  {
    path: "/addLead",
    element: <AddLead />,
  },
  {
    path: "/editLeadDoc",
    element: <EditLead />,
  },
  {
    path: "/userManagement",
    element: <UserManagement />,
  },
];

const LeadManagementDashBoard = (props) => {
  const { width } = useWindowSize();
  return (
    <div>
      {width < 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}>
            <LeadMobileHeader />
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={12} xs={12} md={12} sm={12} className="dashboard-content">
          <Col md={3} className="Left-side-blue">
            <LeadManagementDashboardList />
          </Col>

          <Col md={9} className="right-side-blue">
            <React.Suspense
              fallback={
                <div className="cet-dashobard-loader">
                  <Spin
                    className="cet-loader"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              }
            >
              <Routes>
                <Route
                  path="*"
                  element={
                    <Navigate
                      to="/leadManagementDashboard/leadManagement"
                      replace
                    />
                  }
                />
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.element}
                  />
                ))}
              </Routes>
            </React.Suspense>
          </Col>
        </Col>
      </Row>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    getLeadDetails: (data) => dispatch(getLeadDetails(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    state: state && state.auth,
    lead: state.viewLeadReducer,
    access_token: state && state.auth && state.auth.idToken,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeadManagementDashBoard);
